import {ErrorType as BoVioErrorTypes} from '../../api-types/bovio/response/error'
import {SearchApiError} from '../../sapi/services/searchApi'
import {ErrorDetails} from './ErrorDetails'
import {ErrorTypes} from './ErrorTypes'
/**
 * An {@link ErrorResponse} represents a standardized error response from the BoFH API
 * All endpoints from BoFH API return errors declared in this format.
 */

export enum Psd2AuthErrorTypes {
  INITIALIZATION = 'INITIALIZATION',
  RECOVERABLE = 'RECOVERABLE',
  CARD_ERROR = 'card_error'
}
export interface ErrorResponse {
  details: ErrorDetails
  message?: string
  providerCode?: string
  type?: ErrorTypes | BoVioErrorTypes | SearchApiError
}

export interface BookingError {
  status?: number
  data?: ErrorResponse
}

export type Psd2AuthStatusErrorType = {
  errorDetails?: Psd2AuthErrorType
  errorType?: Psd2AuthErrorTypes
}

export type Psd2AuthErrorType = {
  statusCode?: string
  message?: string
  type?: string
}
